var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 11.4926C31.75 10.9927 23.5656 10.9588 21.9233 18.4591C15.2391 16.1776 9.20377 20.6775 9.83069 27.8624C6.33336 29.276 3.875 32.6927 3.875 36.7085C3.875 41.9964 8.13201 46.2535 13.4199 46.2535H25.0149C25.0117 43.0399 25.0049 36.5918 25.0049 35.3704L22.2858 36.3559C20.3132 37.206 18.8562 34.7219 20.5456 33.1752L25.6905 28.1753C26.8656 27.0003 28.2691 27.135 29.3095 28.1753L34.4544 33.1752C36.1437 34.7219 34.6868 37.206 32.7141 36.3559L29.995 35.3704V46.2535H41.5801C46.868 46.2535 51.125 41.9964 51.125 36.7085C51.125 32.8166 48.8149 29.4896 45.489 28.0008C46.5 15.9925 39.5 12.1849 35 11.4926Z",
    fill: "#75B5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 11.4951C29.8334 16.4951 31.9 26.7951 45.5 27.9951C46.6667 22.4951 44 9.99512 30.5 11.4951Z",
    fill: "#488BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ef185736f00bc68779cacf0cf456b4a6.svg";
export { ForwardRef as ReactComponent };